import React, {Component, Fragment} from "react";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import {Divider, InputNumber, Popconfirm} from "antd";
import FormModal from "../../components/FormModal";
import * as api from "../../api/orderPurchase";


const EditFragment = authWrapper('detail/edit')(Fragment);
const DeletePopConfirm = authWrapper('detail/delete')(Popconfirm);


export const editModalFields = [
    {
        dataIndex: 'id',
        visible: false,
    },
    {
        title: '订购数量',
        dataIndex: 'purchase_qty',
        render: (
            <InputNumber style={{width: '100%'}} />
        )
    },
]

class OrderPurchaseDetail extends Component {

    dataTable = null;

    columns = [
        {
            title: '产品ID',
            dataIndex: 'product_no'
        },
        {
            title: '采购单号/行号',
            render: record => `${record.purchase_no}/${record.line_no}`
        },
        {
            title: '订单数量',
            dataIndex: 'qty',
        },
        {
            title: '库存数量',
            dataIndex: 'stock_qty',
        },
        {
            title: '生产需求量',
            render: (record) => Math.max(record.qty - record.stock_qty, 0)
        },
        {
            title: '主材料名称',
            dataIndex: 'material_name'
        },
        {
            title: '主材料规格',
            dataIndex: 'material_size'
        },
        {
            title: '订购数量',
            dataIndex: 'purchase_qty'
        },
        {
            title: '备注',
            dataIndex: 'remark'
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    {this.props.record.status !== 1 && (
                        <Fragment>
                            <EditFragment>
                                <a onClick={() => this.onEditModalShow(record)}>编辑</a>
                                <Divider type={'vertical'} />
                            </EditFragment>
                            <DeletePopConfirm title={'是否确认删除'} onConfirm={() => this.onDelete(record.id)}>
                                <a>删除</a>
                            </DeletePopConfirm>
                        </Fragment>
                    )}
                </span>
            )
        },
    ]

    state = {
        selectedRecord: null,

        editModalVisible: false,
        editModalSaving: false,
    }

    onEditModalShow = (record) => {
        this.setState({
            selectedRecord: record,
            editModalVisible: true
        })
    }

    onEditModalOk = (fieldsValue) => {
        this.setState({editModalSaving: true})
        api.modifyDetail(fieldsValue.id, fieldsValue['purchase_qty']).then(() => {
            this.setState({editModalSaving: false, editModalVisible: false})
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({editModalSaving: false})
        })
    }

    onDelete = (detailId) => {
        api.deleteDetail(detailId).then(() => {
            this.dataTable.fetch()
        })
    }

    render() {
        const {id} = this.props.record;
        return (
            <div>
                <StandardTable url={'/api/order/purchase/details?purchase_id=' + id}
                               columns={this.columns}
                               ref={table => this.dataTable = table}
                />
                <FormModal fields={editModalFields}
                           visible={this.state.editModalVisible}
                           record={this.state.selectedRecord}
                           onCancel={() => this.setState({editModalVisible: false})}
                           onOk={this.onEditModalOk}
                           confirmLoading={this.state.editModalSaving}
                />
            </div>
        );
    }
}

export default OrderPurchaseDetail;
